import React from "react";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
const styles = require("./styles/menunavigation_styles.module.scss");
import { RouteComponentProps, withRouter } from "react-router-dom";
import Store from "../store/store";
import { observer } from "mobx-react";
import Badge from "@material-ui/core/Badge";

// import sha1 from "simple-sha1";
// import * as jwt from "jsonwebtoken";
// import cookie from "react-cookies";

import axios from "axios";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import SideNav, {
  NavItem,
  NavIcon,
  NavText,
} from "@trendmicro/react-sidenav";
import SearchIcon from "@material-ui/icons/Search";
import MessageIcon from "@material-ui/icons/Message";
import PersonIcon from "@material-ui/icons/Person";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import SettingsIcon from "@material-ui/icons/Settings";
import DescriptionIcon from "@material-ui/icons/Description";
import AddIcon from "@material-ui/icons/Add";
import FileDocument from "@material-ui/icons/InsertDriveFile";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Icon } from "@fluentui/react/lib/Icon"
import IconMA from "@material-ui/core/Icon";
import GroupsIcon from "@material-ui/icons/GroupAdd";


interface State {
  countNbOfMessage: number;
  anchorEl: any;
  open?: boolean;
  valuePassword?: string;
  newPassword?: string;
  displaySearch?: boolean;
  openModal?: boolean;
  isExpandedChoices: {
    param: boolean;
    form: boolean;
  }
  expanded: boolean;
}

let isLoad = false;
@observer
class MenuNavigationSharepoint extends React.Component<RouteComponentProps, State> {
  public constructor(props) {
    super(props);
    this.state = {
      countNbOfMessage: 0,
      expanded: false,
      anchorEl: undefined,
      open: false,
      displaySearch: false,
      valuePassword: undefined,
      newPassword: "",
      openModal: false,
      isExpandedChoices: {
        param: false,
        form: false
      }
    };
  }


  // handleClick = (e) => {
  //   const { target } = e;
  //   this.setState((state) => ({
  //     anchorEl: state.anchorEl ? undefined : target,
  //   }));
  // };

  // public toggleSearch = () => {
  //   this.setState({
  //     displaySearch: !this.state.displaySearch,
  //     expanded: true
  //   })
  // }
  // getValueLogin = (event: any) => {
  //   Store.userConnected.login = event.target.value;
  // };

  // getValuePassword = (event: any) => {
  //   Store.userConnected.password = event.target.value;
  // };

  // onConnectUser = (_login: string, _password: string) => {
  //   if (_login == undefined || _login == "") {
  //     Store.snackBar.open = true;
  //     Store.snackBar.error = true;
  //     Store.snackBar.message = "LYKA : Identifiant incorrect";
  //   } else {
  //     Store.loadingSpinner = true;
  //     axios
  //       .get(Store.wsPath + "/1/paramYes/getParamYes")
  //       .then((response) => {
  //         if (response.data.authMode == "Local" || _login == "AdminYes") {
  //           const passwordCrypted = sha1.sync(_password);
  //           axios
  //             .get(Store.wsPath + "/1/users/GetUserByConnection", {
  //               params: { login: _login, password: passwordCrypted },
  //             })
  //             .then((response) => {
  //               if (response.data.id) {
  //                 cookie.save("token", response.data, { path: "/" });
  //                 Store.userConnected = response.data;
  //                 /* if (Store.GeneralConfig != undefined && Store.userRiskMenu != undefined) {
  //                   const userRiskFound = Store.userRiskMenu.usersRiskList.find(userId =>  userId == Store.userConnected.id );
  //                   if (userRiskFound != undefined) {
  //                     Store.userRiskMenu.userRisk = true
  //                   } else {
  //                     Store.userRiskMenu.userRisk = false
  //                   }
  //                   if (Store.userRiskMenu.usersRiskList.length >0) {
  //                     Store.parameters.viewParameter = false
  //                     Store.parameters.viewEI = true
  //                     Store.parameters.viewPAQ = false
  //                     Store.iconStatus = {
  //                       ei: true,
  //                       settings: false,
  //                       paq: false
  //                     }
  //                     } else {
  //                     Store.parameters.viewParameter = true
  //                     Store.parameters.viewEI = false
  //                     Store.parameters.viewPAQ = false
  //                     Store.iconStatus = {
  //                       ei: false,
  //                       settings: true,
  //                       paq: false
  //                     }
  //                     }
  //                 }else{
  //                   Store.userRiskMenu.userRisk =false
  //                 } */
  //                 Store.loadingSpinner = false;
  //                 this.props.history.push("/"); // Modifie la page d'accueil de connexion
  //                 // console.log("ETAT DU SPINNER ", Store.loadingSpinner);
  //               } else {
  //                 Store.snackBar.open = true;
  //                 Store.snackBar.error = true;
  //                 Store.snackBar.message =
  //                   "LYKA : Identifiant ou mot de passe incorrect";
  //                 Store.loadingSpinner = false;
  //               }
  //             })
  //             .catch((error) => {
  //               Store.snackBar.open = true;
  //               Store.snackBar.error = true;
  //               Store.snackBar.message =
  //                 "LYKA : Identifiant ou mot de passe incorrect";
  //               Store.loadingSpinner = false;
  //             });
  //         } else {
  //           axios
  //             .post(Store.wsPath + "/login", {
  //               username: _login,
  //               password: _password,
  //             })
  //             .then((response) => {
  //               if (
  //                 response.data != "Unauthorized" &&
  //                 response.data != "Invalid Credentials"
  //               ) {
  //                 const token = response.data;
  //                 const data: any = jwt.decode(response.data);
  //                 axios
  //                   .get(Store.wsPath + "/1/users/GetUserInfo", {
  //                     params: { login: data._json.sAMAccountName },
  //                   })
  //                   .then((response) => {
  //                     Store.userConnected = response.data;
  //                     /* const userRiskFound = Store.userRiskMenu.usersRiskList.find(userId =>  userId == Store.userConnected.id );
  //                           if (userRiskFound != undefined) {
  //                             Store.userRiskMenu.userRisk = true
  //                           } else {
  //                             Store.userRiskMenu.userRisk = false
  //                           }
  //                           if (Store.userRiskMenu.usersRiskList.length >0) {
  //                             Store.parameters.viewParameter = false
  //                             Store.parameters.viewEI = true
  //                             Store.parameters.viewPAQ = false
  //                             Store.iconStatus = {
  //                               ei: true,
  //                               settings: false,
  //                               paq: false
  //                             }
  //                             } else {
  //                             Store.parameters.viewParameter = true
  //                             Store.parameters.viewEI = false
  //                             Store.parameters.viewPAQ = false
  //                             Store.iconStatus = {
  //                               ei: false,
  //                               settings: true,
  //                               paq: false
  //                             }
  //                             } */
  //                     cookie.save("token", token, { path: "/" });
  //                     Store.loadingSpinner = false;
  //                     //  console.log("ETAT DU SPINNER ", Store.loadingSpinner);
  //                     this.props.history.push("/"); // Modifie la page d'accueil de connexion
  //                   })
  //                   .catch((error) => {
  //                     Store.snackBar.open = true;
  //                     Store.snackBar.error = true;
  //                     Store.snackBar.message =
  //                       "LYKA : L'identifiant n'existe pas, veuillez contacter le support";
  //                     Store.loadingSpinner = false;
  //                   });
  //               } else {
  //                 Store.snackBar.open = true;
  //                 Store.snackBar.error = true;
  //                 Store.snackBar.message =
  //                   "LYKA : Identifiant ou mot de passe incorrect";
  //                 Store.loadingSpinner = false;
  //               }
  //             })
  //             .catch((error) => {
  //               Store.snackBar.open = true;
  //               Store.snackBar.error = true;
  //               Store.snackBar.message =
  //                 "LYKA : Identifiant ou mot de passe incorrect";
  //               Store.loadingSpinner = false;
  //             });
  //         }
  //       })
  //       .catch((error) => {
  //         Store.snackBar.open = true;
  //         Store.snackBar.error = true;
  //         Store.snackBar.message =
  //           "LYKA : Identifiant ou mot de passe incorrect";
  //         Store.loadingSpinner = false;
  //       });
  //   }
  // };

  public componentDidMount(): void {
    if (Store.userConnected.id != undefined) {
      this.getAllTasksByUser()
    }
  }

  public getAllTasksByUser = () => {
    // const tempArray: any[] = [];
    axios
      .get(Store.wsPath + "/1/workflows/getAllTasksByUserConnected", {
        params: { id: Store.userConnected.id },
      })
      .then((response) => {
        // for (let i = 0; i < response.data.length; i++) {
        //   const task = Store.allSteps.find(
        //     (step) => step.id == response.data[i].stepId
        //   );
        //   if (task != undefined) {
        //     if (
        //       response.data[i].state == "Non terminé" &&
        //       task.state == "En cours"
        //     ) {
        //       tempArray.push(response.data[i]);
        //     }
        //   }
        // }
        const tempArray: any[] = response.data.filter(task => task.state == "En cours" && task.WfStep.state == "En cours");
        Store.countTaskUser = tempArray.length;
      });
  };

  countNbOfMessage = () => {
    axios
      .get(Store.wsPath + "/1/postIt/getAllPostItByUser", {
        params: {
          idUserConnected: Store.userConnected.id,
        },
      })
      .then((response) => {
        this.setState({ countNbOfMessage: response.data }, () => {
          isLoad = true;
        });
      });
  };

  public toggleMenu = (clickAway?: boolean) => (expanded) => {
    this.setState({ openModal: false })
    if (clickAway) {
      this.setState({ expanded: false });
      Store.menuSharepoint.menuSharepointOpen = false;
    } else {
      this.setState({ expanded: !this.state.expanded });
      Store.menuSharepoint.menuSharepointOpen = !Store.menuSharepoint.menuSharepointOpen;
    }
  };

  public expand = (param: "param" | "form") => event => {
    const paramChoice = this.state.isExpandedChoices;
    if (param == "param") {
      paramChoice.param = !paramChoice.param;
    }
    else if (param == "form") {
      paramChoice.form = !paramChoice.form;
    }
    this.setState({ isExpandedChoices: paramChoice });
  }


  public navigateTo = (selected) => {
    Store.menuSharepoint.menuSharepointOpen = false;
    const to = selected;
    this.setState({ expanded: false });
    if (this.props.location.pathname !== to) {
      this.props.history.push(to);
    }
  };



  // public onDeconnectUser = async () => {
  //   // const iframeConnexion:any = document.getElementById("iframeConnexion");
  //   // console.log("monIframe !!!!!!!",iframeConnexion);
  //   // console.log("monIframe windows !!!!!!!",iframeConnexion.contentWindow);
  //   // await iframeConnexion.contentWindow.postMessage({type:'deconnect', data:true}, "http://localhost:3000");
  //   // Store.userConnected.id = undefined
  //   cookie.remove("token");
  //   if (Store.authMode == "AAD") {
  //     await window.location.assign(
  //       Store.wsPath + "/1/authentication/aadLogout"
  //     );
  //   } else {
  //     this.props.history.push("/");
  //     Store.userConnected = {};
  //     this.setState({
  //       anchorEl: undefined,
  //     });
  //     Store.iconStatus = { document: true, settings: false };
  //   }
  // };

  // goToParamMail = (e) => {
  //   Store.contextualmenu.open = "hidden";
  //   this.props.history.push("/paramMail");
  //   const { target } = e;
  //   this.setState((state) => ({
  //     anchorEl: state.anchorEl ? undefined : target,
  //   }));
  // };

  public openModalAccount = () => {
    Store.menuSharepoint.menuSharepointOpen = true;
    this.setState({
      openModal: !this.state.openModal,
    })
    if (this.state.expanded == false) {
      this.setState({
        openModal: !this.state.openModal,
        expanded: !this.state.expanded
      })
    }
  }

  public renderContent = () => {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        {Store.userConnected.id != undefined ?
          <ClickAwayListener onClickAway={this.toggleMenu(true)}>
            <SideNav
              className={styles.sidenav}
              expanded={this.state.expanded}
              onToggle={this.toggleMenu()}
              onSelect={this.navigateTo}
            >
              <SideNav.Toggle />
              <SideNav.Nav
                className={
                  this.state.expanded == false && window.innerWidth <= 768
                    ? styles.testFunc + " " + styles.navIconsContainerMobile
                    : this.state.expanded == true && window.innerWidth <= 768
                      ? styles.testFuncTwo + " " + styles.navIconsContainerMobile
                      : styles.navIconsContainer
                }
                selected={this.props.location.pathname}
              >
                <NavItem
                  onClick={this.openModalAccount}
                  style={
                    this.props.location.pathname == "/myaccount"
                      ? Store.themeParam.primaryTheme
                      : {}
                  }
                  className={styles.navIcon}
                  active={this.props.location.pathname == "/myaccount"}
                  eventKey="/myaccount"
                  title="Mon compte"
                >

                  <NavIcon>
                    <AccountCircleIcon />
                  </NavIcon>
                  <NavText >
                    <span className={styles.menuName} title={Store.userConnected.firstname + " " + Store.userConnected.lastname}>{Store.userConnected.firstname} {Store.userConnected.lastname}</span>
                  </NavText>
                </NavItem>
                <NavItem
                  className={styles.navIcon}
                  eventKey="/mydashboard"
                  title="Mon tableau de bord"
                  active={this.props.location.pathname == "/" || this.props.location.pathname == "/mydashboard"}
                >
                  <NavIcon>
                    <DeveloperBoardIcon />
                  </NavIcon>
                  <NavText>Mon tableau de bord</NavText>
                </NavItem>
                <NavItem
                  className={styles.navIcon}
                  // eventKey={Store.historyIdWorkflow != undefined ? "/document?w=" + Store.historyIdWorkflow : "/document"}
                  eventKey={"/document"}
                  title="Mon parapheur"
                  active={this.props.location.pathname == "/document"}
                >
                  <NavIcon>
                    <FileDocument />
                  </NavIcon>
                  <NavText>Mon parapheur</NavText>
                </NavItem>

                <NavItem
                  className={styles.navIcon}
                  eventKey="/search"
                  title="Effectuer une Recherche"
                >
                  <NavIcon>
                    <SearchIcon />
                  </NavIcon>
                  <NavText>Effectuer une recherche</NavText>
                </NavItem>
                <NavItem
                  className={styles.navIcon}
                  eventKey="/mytasks"
                  title="Mes tâches"
                >
                  <NavIcon>
                    <Badge
                      badgeContent={Store.countTaskUser}
                      showZero
                      color="primary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      max={999}
                    >
                      <AssignmentLateIcon />
                    </Badge>
                  </NavIcon>
                  <NavText>
                    Mes tâches
                  </NavText>
                </NavItem>
                <NavItem
                  className={styles.navIcon}
                  eventKey="/mymessage"
                  title="Mes messages"
                >
                  <NavIcon>
                    <MessageIcon />
                  </NavIcon>
                  <NavText>
                    Mes messages
                  </NavText>
                </NavItem>
                {Store.userConnected.typeUserLydoc == "ged" || Store.userConnected.typeUserLydoc == "admin" ? (
                  <React.Fragment>
                    <NavItem
                      onClick={() => this.navigateTo("/users")}
                      className={styles.navIcon}
                      active={this.props.location.pathname == "/users"}
                      eventKey="/users"
                      title="Utilisateurs"
                    >
                      <NavIcon>
                        <PersonIcon />
                      </NavIcon>
                      <NavText>Utilisateurs</NavText>
                    </NavItem>
                    <NavItem
                      onClick={() => this.navigateTo("/groups")}
                      className={styles.navIcon}
                      active={this.props.location.pathname == "/groups"}
                      eventKey="/groups"
                      title="Gestion des groupes"
                    >
                      <NavIcon>
                        <GroupsIcon />
                      </NavIcon>
                      <NavText>Gestion des groupes</NavText>
                    </NavItem>
                    <NavItem
                      onClick={() => this.navigateTo("/models")}
                      className={styles.navIcon}
                      active={this.props.location.pathname == "/models"}
                      eventKey="/models"
                      title="Modèles"
                    >
                      <NavIcon>
                        <DescriptionIcon />
                      </NavIcon>
                      <NavText>Modèles</NavText>
                    </NavItem>
                    <NavItem
                      onClick={() => this.navigateTo("/roles")}
                      className={styles.navIcon}
                      active={this.props.location.pathname == "/roles"}
                      eventKey="/roles"
                      title="Rôles"
                    >
                      <NavIcon>
                        <AddIcon />
                      </NavIcon>
                      <NavText>Rôles</NavText>
                    </NavItem>
                  </React.Fragment>
                ) : (
                    ""
                  )}
                <NavItem
                  onClick={() => this.navigateTo("/delegation")}
                  className={styles.navIcon}
                  active={this.props.location.pathname == "/delegation"}
                  eventKey="/delegation"
                  title="Délégations"
                >
                  <NavIcon>
                    <IconMA>safety_divider</IconMA>
                  </NavIcon>
                  <NavText>Délégations</NavText>
                </NavItem>

                <NavItem
                  onClick={this.expand("form")}
                  expanded={this.state.isExpandedChoices.form}
                  eventKey="forms"
                  title="Formulaires"
                  className={styles.navIcon}
                  active={this.props.location.pathname == "/forms" || this.props.location.pathname == "/createForm"}
                >
                  <NavIcon>
                    <Icon className={styles.iconFluent} iconName="OfficeFormsLogoInverse16" />
                  </NavIcon>
                  <NavText>Formulaires</NavText>
                  <NavItem
                    eventKey="/forms"
                    onClick={() => this.navigateTo("/forms")}
                    active={this.props.location.pathname == "/forms"}
                    title="Formulaires"
                  >
                    <NavText>Formulaires</NavText>
                  </NavItem>
                  {Store.userConnected.formRights == "Admin" ? (
                    <NavItem
                      eventKey="/createForm"
                      onClick={() => this.navigateTo("/createForm")}
                      active={this.props.location.pathname == "/createForm"}
                      title="Création formulaire"
                    >
                      <NavText>Création formulaire</NavText>
                    </NavItem>
                  ) : (
                      <React.Fragment />
                    )}
                </NavItem>

                {Store.userConnected.typeUserLydoc == "ged" || Store.userConnected.typeUserLydoc == "admin" ? (
                  <NavItem
                    onClick={this.expand("param")}
                    expanded={this.state.isExpandedChoices.param}
                    eventKey="parameters"
                    title="Paramètres généraux"
                    className={styles.navIcon}
                  >
                    <NavIcon>
                      <SettingsIcon />
                    </NavIcon>
                    <NavText>Paramètres</NavText>
                    <NavItem
                      eventKey="/parameters"
                      onClick={() => this.navigateTo("/parameters")}
                      active={this.props.location.pathname == "/parameters"}
                      title="Démarrage auto"
                      className="SubNavJJ"
                    >
                      <NavText>Paramètres généraux</NavText>
                    </NavItem>
                    <NavItem
                      eventKey="/parameterStartAuto"
                      onClick={() => this.navigateTo("/parameterStartAuto")}
                      active={this.props.location.pathname == "/parameterStartAuto"}
                      title="Démarrage auto"
                    >
                      <NavText>Démarrage Auto</NavText>
                    </NavItem>
                  </NavItem>
                ) : (
                    ""
                  )}
                <NavItem
                  className={styles.navIcon}
                  // eventKey="/"
                  title="Retour"
                >
                  <NavIcon>
                    <img
                      width='100%'
                      height="auto"
                      onClick={() => {
                        {
                          Store.selectedDoc.dataSharepoint != undefined && Store.selectedDoc.dataSharepoint != null && Store.selectedDoc.dataSharepoint.site != undefined && Store.selectedDoc.dataSharepoint.site != undefined && Store.selectedDoc.dataSharepoint.site != null ?
                            window.location.href = Store.selectedDoc.dataSharepoint.site
                            :
                            window.location.href = Store.userConnected.siteUrl
                        }
                      }}
                      src="data:image/png;base64,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" />
                  </NavIcon>
                  <NavText>Retour</NavText>
                </NavItem>
                <NavItem
                  className={styles.versionApp}
                >
                  <NavIcon>
                    <AddIcon />
                  </NavIcon>
                  <NavText>
                    {"V" + process.env.VERSION}
                  </NavText>
                </NavItem>
              </SideNav.Nav>
            </SideNav>
          </ClickAwayListener>
          :
          <React.Fragment></React.Fragment>
        }
      </div>

    );
  };
  public render() {
    if (Store.userConnected.id != undefined && !isLoad) {
      this.countNbOfMessage();
    }
    return (
      <div>
        {this.renderContent()}
      </div>);
  }
}
export default withRouter(MenuNavigationSharepoint);
